import { Grid } from "@mui/material"
import { ReduxState, ShowBase } from "ra-core"
import { FC, useEffect, useMemo, useState } from "react"
import { Content } from "@/components/content/Content"
import DeploymentAlertsCard from "@/components/deployment/DeploymentAlertsCard"
import DeploymentStatusCard from "@/components/deployment/DeploymentStatusCard"
import MaxQueryTimeChart from "@/components/deployment/MaxQueryTimeChart"
import AverageQueryTimeChart from "@/components/deployment/AverageQueryTimeChart"
import QueryErrorsChart from "@/components/deployment/QueryErrorsChart"
import { TimeRangeType } from "@/gen/api/metrics"
import { OdResourcePageProps } from "@/types/resource"
import { useResourceRegister } from "@/utils/resourceRegister"
import { useSelector } from "react-redux"


const DeploymentDashboard: FC<OdResourcePageProps> = (props) => {
  useResourceRegister({ name: 'dbmetrics-maxquerytime' })
  useResourceRegister({ name: 'dbmetrics-averagequerytime' })
  useResourceRegister({ name: 'dbmetrics-queryerrors' })
  
  const [timeRange, setTimeRange] = useState(TimeRangeType.Hour)
  const [endTime, setEndTime] = useState(new Date().toISOString())
  useEffect(() => {
    let timer: number|null = null
    timer = window.setInterval(() => setEndTime(new Date().toISOString()), 60 * 1000)
    return () => {
      !!timer && clearInterval(timer)
    }
  }, [])

  const viewVersion = useSelector<ReduxState, number>((store) => store.admin.ui.viewVersion)
  useEffect(() => {
    setEndTime(new Date().toISOString())
  }, [viewVersion])

  return (
    <ShowBase resource="deployments/dashboard" basePath="" id="1">
      <Content pageName="Deployment Dashboard" resourceName="Deployment Dashboard" >
        <Grid
          container
          spacing={4}
          sx={{ mt: 2 }}
        >
          <Grid item xs={12} md={6}>
            <DeploymentStatusCard />
          </Grid>
          <Grid item xs={12} md={6}>
            <DeploymentAlertsCard />
          </Grid>
          <Grid item xs={12} md={6}>
            <MaxQueryTimeChart timeRange={timeRange} setTimeRange={setTimeRange} endTime={endTime} />
          </Grid>
          <Grid item xs={12} md={6}>
            <AverageQueryTimeChart timeRange={timeRange} setTimeRange={setTimeRange} endTime={endTime} />
          </Grid>
          {/* <Grid item xs={12} md={6}>
            <QueryErrorsChart />
          </Grid> */}
        </Grid>
      </Content>
    </ShowBase>
  )
}

export default DeploymentDashboard;
